/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

// Root
import { Actions as RootActions } from "./modules/root/actions";
import { Getters as RootGetters } from "./modules/root/getters";
import { Mutations as RootMutations } from "./modules/root/mutations";

// User
import { Actions as UserActions } from "./modules/user/actions";
import { Getters as UserGetters } from "./modules/user/getters";
import { Mutations as UserMutations } from "./modules/user/mutations";

// Admin
import { Actions as AdminActions } from "./modules/admin/actions";
import { Getters as AdminGetters } from "./modules/admin/getters";
import { Mutations as AdminMutations } from "./modules/admin/mutations";

// BOT
import { Actions as BotActions } from "./modules/bot/actions";
import { Getters as BotGetters } from "./modules/bot/getters";
import { Mutations as BotMutations } from "./modules/bot/mutations";

// Inbox
import { Actions as InboxActions } from "./modules/inbox/actions";
import { Getters as InboxGetters } from "./modules/inbox/getters";
import { Mutations as InboxMutations } from "./modules/inbox/mutations";

export const RootStore = {
  Getters: RootGetters,
  Actions: RootActions,
  Mutations: RootMutations,
};

export const UserStore = {
  Getters: UserGetters,
  Mutations: UserMutations,
  Actions: UserActions,
};

export const AdminStore = {
  Getters: AdminGetters,
  Mutations: AdminMutations,
  Actions: AdminActions,
};

export const BotStore = {
  Getters: BotGetters,
  Mutations: BotMutations,
  Actions: BotActions,
};

export const InboxStore = {
  Getters: InboxGetters,
  Mutations: InboxMutations,
  Actions: InboxActions,
};
